<template></template>

<script>
import { defineComponent, onMounted, ref } from '@vue/composition-api';

export default defineComponent({
    props: {
        amounts: Array,
    },

    setup(props) {
        onMounted(() => {
            // add responsive wrapper to iframes
            const iframes = document.querySelectorAll('#blogcontainer iframe');

            const wrap = function (toWrap, wrapper) {
                wrapper = wrapper || document.createElement('div');
                toWrap.parentNode.insertBefore(wrapper, toWrap);
                return wrapper.appendChild(toWrap);
            };

            iframes.forEach((iframe) => {
                const wrapper = document.createElement('div');
                wrapper.classList.add('relative', 'aspect-w-16', 'aspect-h-9');

                wrap(iframe, wrapper);
            });
        });

        const showLightbox = ref(false);
        const currentIndex = ref(0);

        return {
            showLightbox,
            currentIndex,
        };
    },

    methods: {
        handleHide() {
            this.showLightbox = false;
        },

        showImg(index) {
            this.currentIndex = index;
            this.showLightbox = true;
        },
    },
});
</script>
